const styles = (theme) => ({
  umr: {
    '& .MuiInputBase-input': {
      textTransform: 'uppercase',
    },
  },
});

export default styles;
